// extracted by mini-css-extract-plugin
module.exports = {"main":"ContattaciTemplate_main__nXGjl","rotation":"ContattaciTemplate_rotation__bV_Sm"};